import { render, staticRenderFns } from "./CreateOrEdit.vue?vue&type=template&id=b49c3faa&"
import script from "./CreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEdit.vue?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./CreateOrEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports